export default "__VITE_ASSET__BjTQWrpE__"